/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listAppPasswords.defs'
export { main as default } from './listAppPasswords.defs'
